<template>
  <b-modal
    id="create-user-modal"
    ref="create-user-modal"
    :title="$t('title.createUserModal')"
    size="sm"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    :ok-title="$t('control.button.create')"
    :cancel-title="$t('control.button.cancel')"
    @ok="onSubmit"
    @cancel="resetForm"
  >
    <div class="row">
      <div class="col-md-12">
        <b-form-group
          :label="$t('control.label.person.login')"
          label-for="login"
          label-class="font-weight-normal text-secondary"
        >
          <b-form-input
            id="login"
            v-model="$v.form.login.$model"
            :state="validateState('login')"
          />
        </b-form-group>
      </div>
      <div class="col-md-12">
        <b-form-checkbox
          id="volunteer"
          v-model="$v.form.volunteer.$model"
          button-variant="primary"
          :state="validateState('volunteer')"
        >
          {{ $t('control.label.person.isVolunteer') }}
        </b-form-checkbox>
      </div>
    </div>
  </b-modal>
</template>

<script>

import { validationMixin } from 'vuelidate';
import {
  required,
} from 'vuelidate/lib/validators';
import people from '../services/People';
import parameters from '../services/Parameters';

export default {
  mixins: [validationMixin],
  data() {
    return {
      form: {
        login: null,
        volunteer: false,
      },
    };
  },
  mounted() {
    if (this.$store.getters['authorization/isAdministrator'] || this.$store.getters['authorization/isApproverAdm']) {
      this.$root.$on('openUserCreateModal', () => {
        this.create();
      });
    }
  },
  validations: {
    form: {
      login: {
        required,
      },
      volunteer: {
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form.login = null;
      this.form.volunteer = false;
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.$nextTick(async () => {
        this.$bvModal.hide('create-user-modal');
        people.baseUrl = this.$store.state.settings.apiBaseUrl;
        parameters.baseUrl = this.$store.state.settings.apiBaseUrl;
        let domain = '';
        if (this.form.volunteer) {
          const result = await parameters.getParameter('VOLUNTEER');
          if (result[1] != null) domain = result[1].title;
        } else {
          const result = await parameters.getParameter('EMPLOYEE');
          if (result[1] != null) domain = result[1].title;
        }
        if (String(domain) !== '') {
          if (this.$store.getters['authorization/data'] != null) people.userId = this.$store.getters['authorization/data'].id;
          const result = await people.createPerson(domain, this.form.login, this.form.volunteer);
          this.resetForm();
          if (result[1] != null) {
            this.$root.$emit('updateUserModal', result[1]);
          }
        }
      });
    },
    showModal() {
      this.$bvModal.show('create-user-modal');
    },
    closeModal() {
      this.$bvModal.hide('create-user-modal');
    },
    create() {
      this.showModal();
    },
  },
};
</script>
